import { isMultistoreApp } from '@ps20-frontend/frontend-models';
import {
  StandaloneProdukt,
  StatePreV5,
  StateV5,
  VorvertragPreV5,
  VorvertragV5,
} from './5_migrate_neugeschaeftSperren.interfaces';

export const migrateNeugeschaeftSperren = (
  previousState: StatePreV5,
  newVersion: number,
): StateV5 => {
  return {
    ...previousState,
    vorvertraege: mapVorvertraege(previousState.vorvertraege),
    fremdVertraege: mapFremdvertraege(previousState.fremdVertraege),
    version: newVersion,
  };
};

function mapVorvertraege(vorvertraege: VorvertragPreV5[]): VorvertragV5[] {
  return (
    vorvertraege &&
    vorvertraege.map(vorvertrag => ({
      ...vorvertrag,
      neugeschaeftSperren: vorvertrag.produktIds.map(id => ({
        appId: id,
        neugeschaeftSperren: isMultistoreApp(id) ? false : vorvertrag.neugeschaeftSperren,
      })),
    }))
  );
}

function mapFremdvertraege(
  vorvertraege: Array<VorvertragPreV5 | StandaloneProdukt>,
): Array<VorvertragV5 | StandaloneProdukt> {
  return (
    vorvertraege &&
    vorvertraege.map(v => {
      if (isVorvertrag(v)) {
        return {
          ...v,
          neugeschaeftSperren: v.produktIds.map(id => ({
            appId: id,
            neugeschaeftSperren: isMultistoreApp(id) ? false : v.neugeschaeftSperren,
          })),
        };
      } else {
        return v;
      }
    })
  );
}

function isVorvertrag(vertrag: VorvertragPreV5 | StandaloneProdukt): vertrag is VorvertragPreV5 {
  return vertrag != null && (vertrag as StandaloneProdukt).einschliessenDetails == null;
}
